export const removerSaltosLines = (text: string): string => {
  return text.replace(/\s+/g, ' ')
}
